import API from 'utils/api';
import { onError } from 'utils/handlers';
import { updateEntidadInfo } from 'store/auth';

export const baseURL = '/estructura-organizacional/entidades/configuracion';

/**
 * GET Configuracion De Entidad
 * @returns {Promise<object>}
 */
export const getConfiguracionDeEntidad = async (dispatch) => {
  try {
    const response = await API.get(baseURL);
    if (dispatch) {
      dispatch(updateEntidadInfo({ configuracion: response.data }));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configuracion De Entidad
 * @param {object} values
 * @returns {Promise<object>}
 */
export const postConfiguracionDeEntidad = async (values, dispatch) => {
  try {
    const response = await API.post(baseURL, values);
    if (dispatch) {
      dispatch(updateEntidadInfo({ configuracion: response.data }));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
